
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { bool_type, option_type, class_type, list_type, record_type, string_type, int32_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { InspectionResultImport_InspectionResultValidationResponse_$reflection } from "../../Shared/Importer.js";
import { PostResponse$1_$reflection, EmptyResponse_$reflection, ClientApiResponse$1_$reflection, FormState_$reflection } from "../../Shared/Shared.js";

export class FileUploadStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotStarted", "Uploading", "Success", "Failed"];
    }
}

export function FileUploadStatus_$reflection() {
    return union_type("Importer.InspectionResult.Types.FileUploadStatus", [], FileUploadStatus, () => [[], [], [], []]);
}

export class FileLink extends Record {
    constructor(RowIndex, InventoryNumber, EntityId, UploadStatus) {
        super();
        this.RowIndex = (RowIndex | 0);
        this.InventoryNumber = InventoryNumber;
        this.EntityId = EntityId;
        this.UploadStatus = UploadStatus;
    }
}

export function FileLink_$reflection() {
    return record_type("Importer.InspectionResult.Types.FileLink", [], FileLink, () => [["RowIndex", int32_type], ["InventoryNumber", string_type], ["EntityId", string_type], ["UploadStatus", FileUploadStatus_$reflection()]]);
}

export class FileValidationStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotChecked", "Linked", "NotLinked"];
    }
}

export function FileValidationStatus_$reflection() {
    return union_type("Importer.InspectionResult.Types.FileValidationStatus", [], FileValidationStatus, () => [[], [["Item", list_type(FileLink_$reflection())]], []]);
}

export class SelectedFile extends Record {
    constructor(Id, File, ValidationStatus) {
        super();
        this.Id = Id;
        this.File = File;
        this.ValidationStatus = ValidationStatus;
    }
}

export function SelectedFile_$reflection() {
    return record_type("Importer.InspectionResult.Types.SelectedFile", [], SelectedFile, () => [["Id", string_type], ["File", class_type("Browser.Types.File", undefined)], ["ValidationStatus", FileValidationStatus_$reflection()]]);
}

export class State extends Record {
    constructor(ValidationResult, ImportActive, ValidateErrorMessage, SelectedFiles, IsVisibleForUserRole, FormState) {
        super();
        this.ValidationResult = ValidationResult;
        this.ImportActive = ImportActive;
        this.ValidateErrorMessage = ValidateErrorMessage;
        this.SelectedFiles = SelectedFiles;
        this.IsVisibleForUserRole = IsVisibleForUserRole;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Importer.InspectionResult.Types.State", [], State, () => [["ValidationResult", option_type(InspectionResultImport_InspectionResultValidationResponse_$reflection())], ["ImportActive", bool_type], ["ValidateErrorMessage", option_type(string_type)], ["SelectedFiles", list_type(SelectedFile_$reflection())], ["IsVisibleForUserRole", bool_type], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ImportData", "DataImported", "Validate", "ValidationCompleted", "AddFiles", "RemoveFile", "SetIsVisibleForUserRole", "LinkUploadStarted", "LinkUploadCompleted", "AllUploadsCompleted", "DownloadTemplate", "DownloadedTemplate", "BlobReceived", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Importer.InspectionResult.Types.Msg", [], Msg, () => [[], [["Item", ClientApiResponse$1_$reflection(InspectionResultImport_InspectionResultValidationResponse_$reflection())]], [["Item", class_type("Browser.Types.FormData", undefined)]], [["Item", ClientApiResponse$1_$reflection(InspectionResultImport_InspectionResultValidationResponse_$reflection())]], [["Item", list_type(class_type("Browser.Types.File", undefined))]], [["Item", string_type]], [["Item", bool_type]], [["fileId", string_type], ["rowIndex", int32_type]], [["fileId", string_type], ["rowIndex", int32_type], ["Item3", ClientApiResponse$1_$reflection(PostResponse$1_$reflection(EmptyResponse_$reflection()))]], [], [], [["Item1", class_type("Fetch.Types.Response")], ["Item2", string_type]], [["Item1", class_type("Browser.Types.Blob", undefined)], ["Item2", string_type]], [["Item", class_type("System.Exception")]]]);
}

